import type { AdminUser } from '@/types/auth';

/** Built-in role the backend grants every permission, whatever its stored list says. */
export const SUPER_ADMIN_ROLE = 'super_admin';

/**
 * Permission needed to open each admin page, matching the permission its
 * list endpoint enforces on the backend. Pages that list through a public
 * endpoint (FAQ, countries, destinations) use `content:read`, the read
 * permission of the content resource that guards their edits.
 */
export const ADMIN_PAGE_PERMISSIONS = {
  dashboard: 'dashboard:read',
  customers: 'customer:read',
  packages: 'package:read',
  orders: 'order:read',
  payments: 'payment:read',
  wallets: 'wallet:read',
  content: 'content:read',
  membershipTiers: 'system:read',
  tax: 'tax:read',
  seo: 'seo:update',
  admins: 'admin:read',
  roles: 'role:read',
  auditLogs: 'audit:read',
  config: 'config:read',
} as const;

/** Whether `admin` (with flattened `permissions`) may use `permission`. */
export function hasAdminPermission(
  admin: AdminUser | null,
  permissions: string[],
  permission: string,
): boolean {
  return admin?.role?.name === SUPER_ADMIN_ROLE || permissions.includes(permission);
}
